"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.CO_SOFT_CREDIT_CHECK = exports.SOFT_CREDIT_CHECK = void 0;
exports.SOFT_CREDIT_CHECK = {
    HEADER: 'Connect to your credit profile',
    BODY_1: "By pressing 'Continue', you authorize Flex to obtain your",
    BODY_CREDIT_REPORT_LINK_TEXT: 'credit report',
    BODY_2: 'in order to conduct a prequalification for credit.',
    LEARN_MORE: 'This step will not affect your credit score ',
    FEDERAL_LAW_DISCLAIMER: 'Federal law requires us to collect this info. ',
    LINK_TEXT: 'Why?',
    INCOME_LABEL: 'Annual income',
    BULLETS: [
        'This process will not affect your credit score',
        'Your income will not impact your initial credit decision',
    ],
    AUTHORIZATION: '',
    CTA: 'Continue'
};
exports.CO_SOFT_CREDIT_CHECK = __assign(__assign({}, exports.SOFT_CREDIT_CHECK), { BODY_1: 'Flex needs access to your', BODY_CREDIT_REPORT_LINK_TEXT: 'credit profile', BODY_2: 'in order to offer you a credit line.', AUTHORIZATION: "By pressing 'Continue', you authorize Flex to obtain your credit report in order to conduct a prequalification for credit." });
